import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { FooterContainer } from 'srcReact/Footer'
import history from 'srcReact/helpers/history'
import Header from 'srcReact/components/common2/Navigation/Header'
import { HeaderLogout } from 'srcReact/components/common2/Navigation/HeaderLogout'
import LightProfileModal from 'srcReact/components/common2/LightProfileModal'
import WidgetSidebar from 'srcReact/components/Widgets/WidgetSidebar'
import config from 'config'
import { ErrorBoundary, useErrorHandler } from 'react-error-boundary'
import ErrorFallback from 'srcReact/ErrorPages/ErrorFallback'
import SideBarMain from 'srcReact/components/common2/Navigation/SideBarMain'
import { useTranslation } from 'react-i18next'
import { commonFeedActions } from 'srcReact/components/common2/FeedsTabContent/actions'
import { commonActions } from 'srcReact/components'
import Modal from 'srcReact/components/common2/Modal'
import SelectCalendarModal from 'srcReact/Pages/IntegrationSettings/components/SelectCalendarModal'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'
import WorkplaceLimitPopin from 'srcReact/components/popinsContent/WorkplaceLimitPopin'
import RateMixrModal from 'srcReact/Mixr/MixrHome/components/MixrRating/components/RateMixrModal'
import { mixrActions } from 'srcReact/Mixr/actions'
import { loginActions } from 'srcReact/LoginPage'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import WriteReviewModal from 'srcReact/Mixr/MixrHome/components/MixrRating/components/WriteReviewModal'

const PageContainer = (props) => {
  const {
    isMobile,
    isTablet,
    loggedIn,
    loggedUser,
    isNative,
    isDesktop,
    current_organization,
    pageTitle,
    pageDescription,
    pageKeywords,
    pageClassName,
    children,
    withHeader,
    withFooter,
    withSidebar,
    isPlainBanner,
    pageScript,
    isModalOpen,
    hasWidgets,
    renderWidgets,
    onWidgetToggle,
    user_properties,
    filesCreation,
    crudFeed,
    isCalendarModalOpen,
    calendarMixrId,
    recurrenceUpdate,
    openedPopinName,
    isPopinOpen,
    subscription,
    rating
  } = props
  const { t } = useTranslation()
  const [error, setError] = useState(false)
  const [isRateMixrModal, setIsRateMixrModal] = useState()
  const [selectedRating, setSelectedRating] = useState(0)
  const [mixrData, setMixrData] = useState(null)
  const [isWriteReviewModalOpen, setIsWriteReviewModalOpen] = useState(false)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   window.addEventListener('error', (error) => handleOnError(error))
  //   return () => {
  //     window.removeEventListener('error', handleOnError)
  //   }
  // }, [])

  useEffect(() => {
    if (
      isNative &&
      user_properties?.profile_picture &&
      user_properties.profile_picture.url !== loggedUser?.profile_picture
    ) {
      const { is_original, mime_type, original_tag, url } = user_properties.profile_picture
      dispatch(loginActions.setPictureDetails(url, original_tag, is_original, mime_type))
    }
  }, [user_properties?.profile_picture])

  useEffect(() => {
    if (user_properties?.mixr_rating?.id_mixr > 0) {
      setMixrData(user_properties?.mixr_rating)
      openRateMixrModal(user_properties.mixr_rating.id_mixr)
    }
  }, [user_properties?.mixr_rating?.id_mixr])

  const openRateMixrModal = (mixrId) => {
    setIsRateMixrModal(true)
    dispatch(commonActions.displayCTA('mixr_rating', mixrId))
  }

  const closeRateMixrModal = () => {
    setIsRateMixrModal(false)
  }

  const openWriteReviewModal = () => {
    setIsWriteReviewModalOpen(true)
  }
  const closeWriteReviewModal = () => {
    setIsWriteReviewModalOpen(false)
    closeRateMixrModal()
  }

  const getHeader = () => {
    const location = history.location.pathname
    const isMessenger = location.match(/messenger/)
    if ((isMobile && isMessenger) || (isTablet && isMessenger) || isNative) return false
    return loggedIn ? <Header /> : <HeaderLogout {...(props.isPlainBanner ? { isPlain: isPlainBanner } : {})} />
  }

  // const handleError = useErrorHandler()

  const handleOnError = (err, info) => {
    //console.log('Error is:: ', err, info)
    setError(err)
  }

  const handleRateMixr = (value, isPublic = 1, reviewMessage = '') => {
    const orgId = getCurrentOrgId()
    setSelectedRating(value)
    dispatch(mixrActions.updateMixrRating(orgId, mixrData.id_mixr, isPublic, value, reviewMessage, false))
  }

  return (
    <ErrorBoundary
      FallbackComponent={() => <ErrorFallback title={t('errorPage.clientTitle')} />}
      onError={handleOnError}>
      <React.Fragment>
        <div className='page-container' id='main-page-container' data-testid='page-container'>
          <div tabIndex={0} className='skip-to-main-content-link'>
            <a href='#mixr-main-section'>{`${t('formlabel.skipTo')} ${t('formlabel.mainContent')}`}</a>
          </div>
          <Helmet>
            <title>{pageTitle}</title>
            {pageDescription && <meta name='description' content={pageDescription} />}
            {pageKeywords && <meta name='keywords' content={pageKeywords} />}
            {pageScript && <script type='application/ld+json'>{JSON.stringify(pageScript)}</script>}
          </Helmet>

          {withHeader && getHeader()}
          {withSidebar && <SideBarMain />}

          <main
            tabIndex={0}
            id='mixr-main-section'
            className={`page-main ${pageClassName} ${!isNative && 'with-header-fixed'}`}>
            {children}
          </main>

          <input type='hidden' id='hidden_mixr_version' value={config.version} />
          <input type='hidden' id='hidden_mixr_env' value={config.mixr_env} />
          {withFooter && <FooterContainer />}
        </div>
        {isModalOpen && <LightProfileModal show={isModalOpen} />}
        {hasWidgets && renderWidgets && <WidgetSidebar onToggle={onWidgetToggle}>{renderWidgets()}</WidgetSidebar>}
        {/* This calendar modal will be opened when "Add to calendar" action is called from Banner */}
        {/* this SelectCalendarModal is opened and closed via redux actions */}
        {isCalendarModalOpen && (
          <Modal
            isOpen={isCalendarModalOpen}
            handleClose={() => {
              dispatch(integrationActions.closeCalendarModal())
            }}>
            <SelectCalendarModal
              mixrId={calendarMixrId}
              recurrenceUpdate={recurrenceUpdate}
              closeModal={() => {
                dispatch(integrationActions.closeCalendarModal())
              }}
              isMixrOrganizer={false}
            />
          </Modal>
        )}
        {openedPopinName === 'billing-workplace-popins' && (
          <WorkplaceLimitPopin
            isNative={isNative}
            workplaceLimit={subscription?.plan?.workplace_limit}
            isPopinOpen={isPopinOpen}
            isBillable={current_organization.info.billable}
            handleClosePopin={() => dispatch(commonActions.closePopin())}
          />
        )}
        {isRateMixrModal && (
          <RateMixrModal
            isOpen={isRateMixrModal}
            closeModal={closeRateMixrModal}
            handleRateMixr={handleRateMixr}
            openWriteReviewModal={openWriteReviewModal}
            isMobileDevice={isMobile || isNative}
            mixr={mixrData}
          />
        )}
        {isWriteReviewModalOpen && (
          <WriteReviewModal
            currentReview={''}
            selectedRatingValue={selectedRating}
            isMobileDevice={isMobile || isNative}
            isOpen={isWriteReviewModalOpen}
            showSendMessageOptions={false}
            handleRateMixr={handleRateMixr}
            closeModal={closeWriteReviewModal}
            loading={rating?.loading}
            error={rating?.error}
            success={rating?.success}
          />
        )}
      </React.Fragment>
    </ErrorBoundary>
  )
}

PageContainer.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageDescription: PropTypes.string,
  pageKeywords: PropTypes.string,
  pageClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  // children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element.isRequired]),
  withHeader: PropTypes.bool,
  withFooter: PropTypes.bool,
  withSidebar: PropTypes.bool,
  isPlainBanner: PropTypes.bool,
  onWidgetToggle: PropTypes.func
}

PageContainer.defaultProps = {
  pageClassName: '',
  pageDescription: '',
  pageKeywords: '',
  // children: {},
  withHeader: true,
  withSidebar: false,
  withFooter: true,
  isPlainBanner: false
}

const mapStateToProps = (state) => {
  const { common, login, organization, lightProfile, commonNewsfeed, integration, mixr } = state
  const { loggedIn, logged, user: loggedUser } = login
  const { rating } = mixr
  const { crudFeed } = commonNewsfeed
  const { isMobile, isTablet, isDesktop, isNative, filesCreation, isPopinOpen, openedPopinName } = common
  const {
    current_organization,
    header: { subscription, user_properties }
  } = organization
  const { isModalOpen } = lightProfile
  const { isModalOpen: isCalendarModalOpen, mixrId: calendarMixrId, recurrenceUpdate } = integration
  return {
    isMobile,
    loggedIn,
    loggedUser,
    isTablet,
    isDesktop,
    isNative,
    current_organization,
    isModalOpen,
    filesCreation,
    crudFeed,
    isCalendarModalOpen,
    calendarMixrId,
    isPopinOpen,
    openedPopinName,
    subscription,
    recurrenceUpdate,
    user_properties,
    rating
  }
}

export default connect(mapStateToProps, null)(PageContainer)
